import { render, staticRenderFns } from "./records.component.vue?vue&type=template&id=6050f969&scoped=true&"
import script from "./records.component.vue?vue&type=script&lang=js&"
export * from "./records.component.vue?vue&type=script&lang=js&"
import style0 from "./records.component.vue?vue&type=style&index=0&id=6050f969&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050f969",
  null
  
)

export default component.exports